import { error, success } from "App/popupMessage";
import React from "react";
import { connect } from "react-redux";
export default function withPopupMessage(WrappedComponent) {
    function Hoc(props) {
        return React.createElement(WrappedComponent, { ...props });
    }
    const mapDispatchToProps = (dispatch) => ({
        showInfo: (message) => dispatch(success(message)),
        showError: (message) => dispatch(error(message))
    });
    return connect(undefined, mapDispatchToProps)(Hoc);
}
